/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFaceSmile: {
  name: 'face-smile';
  data: string;
} = {
  name: 'face-smile',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM4.968 9.75a.5.5 0 1 0-.866.5A4.498 4.498 0 0 0 8 12.5c1.666 0 3.12-.906 3.898-2.25a.5.5 0 1 0-.866-.5A3.498 3.498 0 0 1 8 11.5a3.498 3.498 0 0 1-3.032-1.75ZM6 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
